const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export interface FormDraft<T> {
  savedAt: number;
  data: T;
}

export function getFormDraft<T>(key: string): FormDraft<T> | null {
  if (typeof localStorage === 'undefined') return null;

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as FormDraft<T>;
    if (!parsed || typeof parsed.savedAt !== 'number' || parsed.data === undefined) {
      localStorage.removeItem(key);
      return null;
    }

    if (Date.now() - parsed.savedAt > DRAFT_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function setFormDraft<T>(key: string, data: T): void {
  if (typeof localStorage === 'undefined') return;

  try {
    const draft: FormDraft<T> = { savedAt: Date.now(), data };
    localStorage.setItem(key, JSON.stringify(draft));
  } catch {
    // Quota / private mode — ignore; quiet reauth still covers the common case.
  }
}

export function clearFormDraft(key: string): void {
  if (typeof localStorage === 'undefined') return;

  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function clearFormDraftsByPrefix(prefix: string): void {
  if (typeof localStorage === 'undefined') return;

  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      localStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}

export function addGameDraftKey(userId: string): string {
  return `dev-portal:game-add:${userId}`;
}

export function editGameDraftKey(userId: string, gameId: string): string {
  return `dev-portal:game-edit:${userId}:${gameId}`;
}

export const DEV_PORTAL_DRAFT_PREFIX = 'dev-portal:';
